import type { FC } from 'react';

import Icon from '../../ui/Icon/Icon';

export type TItemType = 'page' | 'prev' | 'next' | 'jump-prev' | 'jump-next';

export interface IItemProps {
  type: TItemType;
  page: number;
  isActive: boolean;
}

const Item: FC<IItemProps> = ({ type, page, isActive }) => {
  switch (type) {
    case 'page':
      return <span className={`item-page ${isActive ? 'item-page-active' : ''}`}>{page}</span>;
    case 'next':
    case 'prev':
      return (
        <span className={`item-btn item-btn-${type}`}>
          <Icon name={`arrow-${type === 'next' ? 'right' : 'left'}`} size={20} asVector />
        </span>
      );
    default:
      return null;
  }
};

export default Item;
